import type {ProductTourSectionSliceDefaultPrimaryDialogItem} from 'prismicio-types'
import {memo} from 'react'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {RecaptchaWrapper} from 'slices/BookDemoSection/RecaptchaWrapper'
import {ButtonV2} from 'src/common/ButtonV2'
import type {Context} from 'src/common/types'
import {LeadGenerationForm} from './LeadGenerationForm'

interface TourOverlayProps {
  showLeadForm: boolean
  dialogContent?: ProductTourSectionSliceDefaultPrimaryDialogItem[]
  startTourButtonLabel?: string
  context: Context
  onStartTour: () => void
  onLeadSubmit: () => void
}

export const TourOverlay = memo<TourOverlayProps>(
  ({showLeadForm, dialogContent, startTourButtonLabel, context, onStartTour, onLeadSubmit}) => {
    if (showLeadForm && dialogContent && dialogContent.length > 0) {
      return (
        <RecaptchaWrapper>
          <LeadGenerationForm content={dialogContent[0]} pageUid={context.pageUid} callbackAfterSubmit={onLeadSubmit} />
        </RecaptchaWrapper>
      )
    }

    return (
      <ButtonV2
        trackingData={{
          mktgId: 'product-tour-start-tour-button',
          dataType: 'start-tour-button',
          location: 'product-tour-section',
          pageName: context.pageUid || '',
        }}
        newTrackingProps={{
          interaction: {
            element: 'product-tour-start-tour-button',
            location: 'product-tour-section',
            elementText: startTourButtonLabel || '',
          },
          pageType: context.pageUid || '',
        }}
        variant="primary"
        className="!h-16 text-15"
        onClick={onStartTour}
      >
        {startTourButtonLabel}
      </ButtonV2>
    )
  },
)
